import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialWebsiteState: Dtos.TrialWebsite & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    registered: null,
    enquiryEmail: null,
    phoneNumber: null,
    live: null,
    hidePublic: null,
    shortDescription: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialWebsiteReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    trial: IFieldState<Dtos.Trial>,
    registered: IFieldState<string>,
    enquiryEmail: IFieldState<string>,
    phoneNumber: IFieldState<string>,
    live: IFieldState<boolean>,
    hidePublic: IFieldState<boolean>,
    shortDescription: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    sourceDocuments: IFieldState<Dtos.SourceDocument[]>,
}
